<template>
  <v-container :fluid="$vuetify.breakpoint.mobile">
    <div class="section">
      <h2>Concours de créateur</h2>
    </div>
    <v-row>
      <v-col cols="12">
        <v-img
            alt="Logo Sablier Ludinam"
            class="ma-auto"
            contain
            src="../../assets/image/sablier.png"
            max-width="200px"
        />
      </v-col>
      <v-col cols="12" v-html="text"/>
    </v-row>
  </v-container>
</template>

<script>
import GlobalParamsService from "../../services/global_params.service";
export default {
  name: "Createur",
  data: () => ({
    url:null,
    text:null,
  }),
  created() {
    GlobalParamsService.getConcoursCreateur().then(response => {
      this.text = response['data'].value.text;
    });
  },
};
</script>

<style lang="scss" scoped>
</style>
